<div class="event-list__main"
  [hidden]="isLoading">
  <div class="event-list__main-list"
    [ngClass]="{'visible-xl-min' : eventDetails}">
    @if (invites?.length) {
      <h3>{{organisationLabelTags.Invitations | translate}}</h3>
    }
    @for (event of invites; track event; let i = $index) {
      <ng-container *ngTemplateOutlet="eventTemplate; context: {event, i, events: invites}"></ng-container>
    }
    @if (invites?.length && events?.length) {
      <h3>{{organisationLabelTags.Diary | translate}}</h3>
    }
    @for (event of events; track event; let i = $index) {
      <ng-container *ngTemplateOutlet="eventTemplate; context: {event, i, events}"></ng-container>
    }
    @if (events?.length === 0) {
      <sb-alert
        alertClass="info"
        customClasses="mt-3"
        [isSmall]="true"
      message="SB_No_Events_Found"></sb-alert>
    }
  </div>
  <div class="event-list__main-content"
    [ngClass]="{'visible-xl-min' : !eventDetails}">
    @if (!eventDetails) {
      <sb-detail placeholderText="SB_Select_An_Event_To_View"
        placeholderIcon="diary"
      ></sb-detail>
    }
    <div [hidden]="!eventDetails"
      class="event-list__main-event">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<ng-template #eventTemplate let-event="event" let-i="i" let-events="events">
  @if (hasDateChangedSinceLastRow(i, events)) {
    <div class="diary-date">
      <div [innerHTML]="event.eventDate | date: 'EEEE, dd MMM'"></div>
    </div>
  }
  <sb-diary-item [event]="event"
    [isBorderless]="true"
    [isSelected]="eventDetails?.calendarEventId === event.id && eventDetails?.personId === event.personId"
  (onClick)="selectRow(event)"></sb-diary-item>
</ng-template>
